// Module
var code = "<bringoz-button type=\"tertiary\" size=\"fit\" (on-click)=\"$ctrl.onToggleSort($event)\"> <bringoz-icon icon-name=\"sort-list\"></bringoz-icon> </bringoz-button> ";
// Exports
export default code;